<template>
  <div>
    <Modal v-model="showDetail" :mask-closable="false" width="600px" :closable="false" :title="title">
      <Spin size="large" fix v-if="loading"></Spin>
      <!-- <Row>
                    <Col span="24" class="ctime">{{ dateil.mould['creationTime'] | dateformat('YYYY-MM-DD HH:mm:ss') }}</Col>
            </Row> -->
      <div class="dd">
        <div class="top_info">
          <Row>
            <Col span="4"><b>设计者</b></Col>
            <Col span="8">{{ dateil.mould['c设计者'] }}</Col>
            <Col span="4"><b>客户名称</b></Col>
            <Col span="8">{{ dateil.mould['c客户名称'] }}</Col>
            <Col span="4"><b>产品名称</b></Col>
            <Col span="8">{{ dateil.mould['c模具名称'] }}</Col>
            <Col span="4"><b>产品型号</b></Col>
            <Col span="8">{{ dateil.mould['c模具型号'] }}</Col>
            <Col span="4"><b>数量</b></Col>
            <Col span="8">{{ dateil.mould['c数量'] }}</Col>
            <Col span="4"><b>类型</b></Col>
            <Col span="8">{{ dateil.mould['c类型'] }}</Col>
            <Col span="4"><b>事业部</b></Col>
            <Col span="8">{{ dateil.mould['causeDepartmentText'] }}</Col>
            <!-- <Col span="4"><b>当前状态</b></Col>
                        <Col span="8">{{ dateil.mould['statusText'] }}</Col> -->
            <Col span="4"><b>计划完成时间</b></Col>
            <Col span="8">{{ dateil.mould['c计划完成时间'] | dateformat('YYYY-MM-DD') }}</Col>
            <Col span="4"><b>创建时间</b></Col>
            <Col span="8">{{ dateil.mould['creationTime'] | dateformat('YYYY-MM-DD HH:mm') }}</Col>
          </Row>
        </div>
        <div>
          <Tabs v-if="dateil.tasks && dateil.tasks.length > 0" class="box">
            <TabPane v-for="(item, index) in dateil.tasks" :key="index" :label="item.taskName" :name="'name' + index">
              <Timeline>
                <TimelineItem>
                  <p class="time">任务基本信息</p>
                  <p class="content">
                    <b>状态：</b>
                    {{ item.statusText }}
                  </p>
                  <p class="content">
                    <b>任务来源：</b>
                    {{ item.taskSourceText }}
                  </p>
                  <p class="content">
                    <b>创建人：</b>
                    {{ item['addTaskName'] }}
                  </p>
                  <p class="content">
                    <b>创建时间：</b>
                    {{ item['addTaskTime'] | dateformat('YYYY-MM-DD HH:mm') }}
                  </p>
                  <p class="content">
                    <b>任务说明：</b>
                    {{ item['taskExplain'] ? item['taskExplain']:'无'}}
                  </p>

                  <p class="content">
                    <b>相关文件：</b>
                    {{ item.taskFileList[0].sceneDataTaskFilesList.length == 0 ? '无' : '' }}
                  </p>
                  <div style="margin: 5px 0px 0px 0px">
                    <template v-for="(img, img_i) in item.taskFileList[0].sceneDataTaskFilesList">
                      <span :key="img_i" class="pos" @click="magnify(false, img.url)"
                        v-if="img.fileName.toLowerCase().indexOf('.jpg') > -1 || img.fileName.toLowerCase().indexOf('.jpeg') > -1 || img.fileName.toLowerCase().indexOf('.png') > -1 || img.fileName.toLowerCase().indexOf('.gif') > -1">
                        <img class="img" :src="url + img.url" width="80px" height="80px" />
                        <i class="img_magnify">
                          <Icon size="26" color="#ffffff" class="ico" type="ios-search" />
                        </i>
                      </span>
                      <span :key="img_i" class="pos" @click="magnify(true, img.url)" v-else>
                        <img class="img" v-if="img.fileName.toLowerCase().indexOf('.pdf') > -1" :src="require('@/assets/images/pdf.png')" width="80px" height="80px" />
                        <img class="img" v-if="img.fileName.toLowerCase().indexOf('.word') > -1 || img.fileName.toLowerCase().indexOf('.doc') > -1" :src="require('@/assets/images/word.png')" width="80px" height="80px" />
                        <img class="img"
                          v-if="img.fileName.toLowerCase().indexOf('.excel') > -1 || img.fileName.toLowerCase().indexOf('.excl') > -1 || img.fileName.toLowerCase().indexOf('.xlsx') > -1 || img.fileName.toLowerCase().indexOf('.xls') > -1"
                          :src="require('@/assets/images/excel.png')" width="80px" height="80px" />
                        <img class="img" v-if="img.fileName.toLowerCase().indexOf('.txt') > -1" :src="require('@/assets/images/txt_1.png')" width="80px" height="80px" />
                        <i class="img_magnify">
                          <Icon size="26" color="#ffffff" class="ico" type="ios-search" />
                        </i>
                      </span>
                    </template>
                  </div>
                  <div v-if="item['status'] > $constDefinition.待业务员审批&&item.isCharge!=null">
                    <p class="content">
                      <b>是否收费：</b>
                      {{ item.isCharge ? '是' : '否' }}
                    </p>
                    <p class="content">
                      <b>确认人：</b>
                      {{ item.approvalTaskName }}
                    </p>
                    <p class="content">
                      <b>确认时间：</b>
                      {{ item.approvalTaskTime | dateformat('YYYY-MM-DD HH:mm') }}
                    </p>
                  </div>
                </TimelineItem>
                <TimelineItem v-if="item['status'] > $constDefinition.待指派售后人员">
                  <p class="time">派工情况</p>
                  <p class="content">
                    <b>当前状态：</b>
                    {{ item['statusText'] }}
                  </p>
                  <p class="content">
                    <b>售后人员：</b>
                    {{ item['status'] > $constDefinition.待指派售后人员 ? item['afterSalePerson'] : '暂未指派人员' }}
                  </p>
                  <p class="content" v-show="item['status'] > $constDefinition.task待指派售后人员 && item['approvelManagerName']">
                    <b>总经理：</b>
                    {{ item['approvelManagerName'] }}
                  </p>
                  <p class="content">
                    <b>派单时间：</b>
                    {{ item['distributeTime'] | dateformat('YYYY-MM-DD HH:mm') }}<span v-if="item.接单时间差 > 6" style="color: red">（超时）</span>
                  </p>
                  <p class="content" v-show="item['status'] > $constDefinition.待售后人员接单 && item['orderReceivingTime']">
                    <b>接单时间：</b>
                    {{ item['orderReceivingTime'] | dateformat('YYYY-MM-DD HH:mm') }}
                  </p>
                  <p class="content" v-show="item['status'] > $constDefinition.待售后服务 && item['startServiceTime']">
                    <b>开始服务时间：</b>
                    {{ item['startServiceTime'] | dateformat('YYYY-MM-DD HH:mm') }}
                  </p>
                  <div class="content" v-show="item['status'] > $constDefinition.待售后服务 && item['startServiceTime']">
                    <b>开始服务图片：</b>
                    <div style="margin: 10px 0px 0px 0px" v-if="item.startServiceFileList[0].sceneDataTaskStartServiceFilesList.length > 0">
                      <template v-for="(img, img_i) in item.startServiceFileList[0].sceneDataTaskStartServiceFilesList">
                        <span :key="img_i" class="pos" @click="magnify(false, img.url)">
                          <img class="img" :src="url + img.url" width="80px" height="80px" />
                          <i class="img_magnify">
                            <Icon size="26" color="#ffffff" class="ico" type="ios-search" />
                          </i>
                        </span>
                      </template>
                    </div>
                    <span v-else>无</span>
                  </div>
                </TimelineItem>
                <TimelineItem v-if="item['status'] > $constDefinition.待售后人员录入问题">
                  <Form ref="form" :model="form" :rules="ruleCustom" :label-width="80">
                    <p class="time">施工情况</p>
                    <p class="content">
                      <b>有无问题：</b>
                      {{ item['isFeedBack'] ? '有' : '无' }}
                    </p>
                    <p class="content" v-if="item['isFeedBack']">
                      <b>工艺人员：</b>
                      {{ item['processDeptUserName'] }}
                    </p>
                    <div v-if="item['isFeedBack']">
                      <Collapse v-if="item.problemList && item.problemList.length > 0">
                        <Panel :name="i + ''" v-for="(it, i) in item.problemList" :key="i">
                          问题{{ i + 1 }} [ <span class="typeCls"> {{it.questionSolveTypeText}}</span>]
                          <template #content>
                            <div class="wrap" v-if="item['status'] > $constDefinition.待售后人员录入问题">
                              <p class="t_c">
                                <span style="font-size: 14px; font-weight: 600">问题描述({{ it['c问题描述Name'] }})：</span>
                                <span class="time">{{ it['c问题描述Time'] | dateformat('YYYY-MM-DD HH:mm') }}</span>
                              </p>
                              <p style="margin-top: 10px">{{ it['c问题描述'] }}</p>
                              <div style="margin: 10px 0px 0px 0px">
                                <template v-for="(img, img_i) in it.sceneFeedBackFilesList">
                                  <span :key="img_i" class="pos" @click="magnify(false, img.url)">
                                    <img class="img" :src="url + img.url" width="80px" height="80px" />
                                    <img />
                                    <i class="img_magnify">
                                      <Icon size="26" class="ico" color="#ffffff" type="ios-search" />
                                    </i>
                                  </span>
                                </template>
                              </div>
                            </div>
                            <!-- 录入时 -->
                            <div class="wrap" v-if="it.isShow录入解决方案Input&&title=='录入解决方案'">

                              <p class="t_c">
                                <span style="font-size: 14px; font-weight: 600">解决方案({{ it['c问题解决Name'] }})：</span>
                                <span class="time">{{ it['c问题解决Time'] | dateformat('YYYY-MM-DD HH:mm') }}</span>
                              </p>
                              <p style="margin-top: 10px">{{ it['c问题解决'] }}</p>
                              <div style="margin: 10px 0px 0px 0px">
                                <template v-for="(img, img_i) in it.sceneFeedBackFilesSolutionList">
                                  <span :key="img_i" class="pos" @click="magnify(false, img.url)">
                                    <img class="img" :src="url + img.url" width="80px" height="80px" />
                                    <img />
                                    <i class="img_magnify">
                                      <Icon size="26" class="ico" color="#ffffff" type="ios-search" />
                                    </i>
                                  </span>
                                </template>
                              </div>
                              <div>
                                <FormItem label="问题类型" :rules="{required: true, message: '请选择问题类型',type:'number', trigger: 'blur'}" :prop="'sceneFeedBackCreatelist['+i+'].questionType'">
                                  <!-- <Input type="textarea" :maxlength="200" show-word-limit v-model="form.sceneFeedBackCreatelist[i].questionType"></Input> -->
                                  <RadioGroup v-model="form.sceneFeedBackCreatelist[i].questionType">
                                    <Radio :label="item.value" v-for="(item,index) in questionTypeList" :key="index">{{item.name}}</Radio>

                                  </RadioGroup>
                                </FormItem>
                                <FormItem label="解决方案" :rules="{required: true, message: '请输入解决方案', trigger: 'blur'}" :prop="'sceneFeedBackCreatelist['+i+'].c问题解决'">
                                  <Input type="textarea" :maxlength="200" show-word-limit v-model="form.sceneFeedBackCreatelist[i].c问题解决"></Input>
                                </FormItem>
                                <FormItem>

                                  <div style="margin: 10px 0px 0px 0px; display: contents;" v-if="form.sceneFeedBackCreatelist[i].sceneFeedBackFilesSolutionList.length > 0">
                                    <template v-for="(img, img_i) in form.sceneFeedBackCreatelist[i].sceneFeedBackFilesSolutionList">
                                      <span :key="img_i" class="pos">
                                        <img class="img" :src="url + img.url" width="80px" height="80px" />
                                        <i class="img_magnify">
                                          <div class="hander2">
                                            <Icon size="26" @click="magnify(false, img.url)" color="#ffffff" type="ios-search" />
                                            <Icon size="26" color="#ffffff" @click="handleRemoveys(i,img_i)" type="ios-trash-outline" />
                                          </div>

                                        </i>
                                      </span>
                                    </template>
                                  </div>
                                  <Upload :ref="'upload'+i" :show-upload-list="true" :on-success="handleSuccess" :data='{id:i,guid:newGuid}' accept="jpg,jpeg,png" :format="['jpg','jpeg','png']" :max-size="2048"
                                    :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" multiple type="drag" :action="$constDefinition.baseUrl+'/file/UploadBySceneDataTaskSolution_PC'"
                                    style="display: inline-block;width:80px;">
                                    <div style="width: 80px;height:80px;line-height: 80px;">
                                      <Icon type="ios-camera" size="20"></Icon>
                                    </div>
                                  </Upload>
                                </FormItem>
                              </div>
                            </div>
                            <!-- 详情时 -->
                            <div class="wrap" v-if="it.isShow录入解决方案Text">
                              <p class="t_c">
                                <span style="font-size: 14px; font-weight: 600">解决方案({{ it['c问题解决Name'] }})：</span>
                                <span class="time">{{ it['c问题解决Time'] | dateformat('YYYY-MM-DD HH:mm') }}</span>
                              </p>
                              <p style="margin-top: 10px">{{ it['c问题解决'] }}（<span class="typeCls">问题类型：{{it.questionTypeText}}</span>）</p>
                              <div style="margin: 10px 0px 0px 0px">
                                <template v-for="(img, img_i) in it.sceneFeedBackFilesSolutionList">
                                  <span :key="img_i" class="pos" @click="magnify(false, img.url)">
                                    <img class="img" :src="url + img.url" width="80px" height="80px" />
                                    <img />
                                    <i class="img_magnify">
                                      <Icon size="26" class="ico" color="#ffffff" type="ios-search" />
                                    </i>
                                  </span>
                                </template>
                              </div>
                            </div>
                            <div class="wrap" v-if="item['status'] > $constDefinition.待售后处理问题">
                              <p class="t_c">
                                <span style="font-size: 14px; font-weight: 600">施工情况({{ it['c处理问题Name'] }})：</span>
                                <span class="time">{{ it['c处理问题Time'] | dateformat('YYYY-MM-DD HH:mm') }}</span>
                              </p>
                              <p style="margin-top: 10px">{{ it['c处理问题'] }}</p>
                              <div style="margin: 10px 0px 0px 0px">
                                <template v-for="(img, img_i) in it.sceneFeedBackResolveFilesList">
                                  <span :key="img_i" class="pos" @click="magnify(false, img.url)">
                                    <img class="img" :src="url + img.url" width="80px" height="80px" />
                                    <img />
                                    <i class="img_magnify">
                                      <Icon size="26" class="ico" color="#ffffff" type="ios-search" />
                                    </i>
                                  </span>
                                </template>
                              </div>
                            </div>
                            <!-- <div class="wrap" v-if="item['status'] > $constDefinition.待客户验收">
                              <p class="t_c">
                                <span style="font-size: 14px; font-weight: 600">验收情况({{ it['c验收问题Name'] }})：</span>
                                <span class="time">{{ it['c验收问题Time'] | dateformat('YYYY-MM-DD HH:mm') }}</span>
                              </p>
                              <p style="margin-top: 10px">{{ it['c验收问题'] }}</p>
                              <div style="margin: 10px 0px 0px 0px">
                                <template v-for="(img, img_i) in it.sceneFeedBackAcceptFilesList">
                                  <span :key="img_i" class="pos" @click="magnify(false, img.url)">
                                    <img class="img" :src="url + img.url" width="80px" height="80px" />
                                    <img />
                                    <i class="img_magnify">
                                      <Icon size="26" class="ico" color="#ffffff" type="ios-search" />
                                    </i>
                                  </span>
                                </template>
                              </div>
                            </div> -->
                          </template>
                        </Panel>
                      </Collapse>
                    </div>
                    <!-- 无问题时 -->
                    <div v-else>
                      <p class="content">
                        <b>验收情况</b>
                        {{ item.problemList[0]['c问题描述'] }}
                      </p>
                      <p class="content">
                        <b>操作人：</b>
                        {{ item.problemList[0]['c问题描述Name'] }}
                      </p>
                      <p class="content">
                        <b>操作时间：</b>
                        {{ item.problemList[0]['c问题描述Time'] | dateformat('YYYY-MM-DD HH:mm') }}
                      </p>
                      <div style="margin: 10px 0px 0px 0px">
                        <template v-for="(img, img_i) in item.problemList[0].sceneFeedBackFilesList">
                          <span :key="img_i" class="pos" @click="magnify(false, img.url)">
                            <img class="img" :src="url + img.url" width="80px" height="80px" />
                            <i class="img_magnify">
                              <Icon size="26" class="ico" color="#ffffff" type="ios-search" />
                            </i>
                          </span>
                        </template>
                      </div>
                    </div>
                  </Form>
                </TimelineItem>
                <!-- 客户验收 -->
                <TimelineItem v-if="dateil.mould.isShow_客户验收Text">
                  <p class="time">客户验收</p>
                  <p class="content">
                    <b>验收描述：</b>
                    {{ item['taskAccept'] }}
                  <div style="margin: 10px 0px 0px 0px" v-if="item.sceneDataItemTaskTaskAcceptFilesList.length > 0">
                    <template v-for="(img1) in item.sceneDataItemTaskTaskAcceptFilesList">
                      <template v-for="(img, img_i) in img1.sceneDataTaskTaskAcceptFilesList">
                        <span :key="img_i" class="pos" @click="magnify(false, img.url)">
                          <img class="img" :src="url + img.url" width="80px" height="80px" />
                          <i class="img_magnify">
                            <Icon size="26" class="ico" color="#ffffff" type="ios-search" />
                          </i>
                        </span>
                      </template>
                    </template>
                  </div>
                  </p>
                  <p class="content">
                    <b>操作人：</b>
                    {{ item['taskAcceptUserName'] }}
                  </p>
                  <p class="content">
                    <b>操作时间：</b>
                    {{ item['taskAcceptTimeText']}}
                  </p>
                </TimelineItem>
                <TimelineItem v-if="item['status'] > $constDefinition.待客户验收&&dateil.mould.isShow_业务员审批&&title=='验收'">
                  <p class="time">业务员验收</p>
                  <Form :model="form" style="background:#e7e7e7;padding:10px ;" :rules="ruleCustom" label-position="top" ref="formys">
                    <FormItem label="验收描述" :rules="{required: true, message: '请输入验收描述', trigger: 'blur'}" :prop="'businessConfirmDescribe'">
                      <Input type="textarea" :maxlength="200" show-word-limit v-model="form.businessConfirmDescribe"></Input>
                    </FormItem>
                    <div class="up">
                      <FormItem>
                        <div style="margin: 10px 0px 0px 0px; display: contents;" v-if="form.sceneDataItemTaskBusinessConfirmFilesList&&form.sceneDataItemTaskBusinessConfirmFilesList.length > 0">
                          <template v-for="(img, img_i) in form.sceneDataItemTaskBusinessConfirmFilesList">
                            <span :key="img_i" class="pos">
                              <img class="img" :src="url + img.url" width="80px" height="80px" />
                              <i class="img_magnify">
                                <div class="hander2">
                                  <Icon size="26" @click="magnify(false, img.url)" color="#ffffff" type="ios-search" />
                                  <Icon size="26" color="#ffffff" @click="handleRemoveys(img_i)" type="ios-trash-outline" />
                                </div>
                              </i>
                            </span>
                          </template>
                        </div>
                        <Upload :ref="'uploadys'" :show-upload-list="true" :on-success="handleSuccessys" :data='{guid:newGuid,id:taskId}' accept="jpg,jpeg,png" :format="['jpg','jpeg','png']" :max-size="2048"
                          :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" multiple type="drag" :action="$constDefinition.baseUrl+'/file/UploadBySceneDataTaskBusinessConfirmFile'"
                          style="display: inline-block;width:80px;">
                          <div style="width: 80px;height:80px;line-height: 80px;">
                            <Icon type="ios-camera" size="20"></Icon>
                          </div>
                        </Upload>
                        <!-- <ImagePreview v-model="visible" :preview-list="['https://file.iviewui.com/images/' + imgName]" /> -->
                      </FormItem>
                    </div>
                    <!-- <Button @click="imgShow = false" type="primary" class="close-btn">提交验收</Button> -->

                  </Form>
                </TimelineItem>
                <TimelineItem v-if="item['status'] > $constDefinition.客户已验收">
                  <p class="time">业务员验收</p>
                  <p class="content">
                    <b>验收描述：</b>
                    {{ item['businessConfirmDescribe'] }}
                  <div style="margin: 10px 0px 0px 0px" v-if="item.businessConfirmFileList[0].sceneDataTaskBusinessConfirmFilesList.length > 0">
                    <template v-for="(img, img_i) in item.businessConfirmFileList[0].sceneDataTaskBusinessConfirmFilesList">
                      <span :key="img_i" class="pos" @click="magnify(false, img.url)">
                        <img class="img" :src="url + img.url" width="80px" height="80px" />
                        <i class="img_magnify">
                          <Icon size="26" class="ico" color="#ffffff" type="ios-search" />
                        </i>
                      </span>
                    </template>
                  </div>
                  </p>
                  <p class="content">
                    <b>业务员：</b>
                    {{ item['businessConfirmName'] }}
                  </p>
                  <p class="content">
                    <b>确认时间：</b>
                    {{ item['businessConfirmTime'] | dateformat('YYYY-MM-DD HH:mm') }}
                  </p>
                </TimelineItem>
              </Timeline>
              <Button @click="openCz(item.id)" type="primary" class="close-btn">操作记录</Button>
            </TabPane>
          </Tabs>
        </div>

      </div>
      <div slot="footer">
        <!-- <Button @click="okys" v-if="dateil.mould.isShow_业务员审批" type="primary" class="close-btn"> 提交</Button> -->
        <Button @click="exportTaskProblemList" type="primary" v-if="title=='详情'" class="close-btn">导出产品问题清单</Button>
        <Button @click="close(false)" class="close-btn">关闭</Button>
        <template v-if="title=='录入解决方案'">
          <Button @click="isShowResolveQuestion=true" type="warning" class="close-btn">流转</Button>
          <Button @click="ok" type="primary" :loading="Uploading" class="close-btn">
            <span v-if="!Uploading">提交</span>
            <span v-else>等待图片上传完成..</span></Button>
        </template>
        <template v-if="title=='验收'">
          <Button @click="okys" type="primary" :loading="Uploading" class="close-btn">
            <span v-if="!Uploading">提交</span>
            <span v-else>等待图片上传完成..</span></Button>
        </template>
      </div>
    </Modal>
    <!-- 操作记录 -->
    <Modal v-model="czShow" class="cz" :mask-closable="false" width="500px" :closable="false" title="操作记录">
      <Spin size="large" fix v-if="rzLoading"></Spin>
      <Timeline>
        <TimelineItem v-for="(log ,log_i) in logList" :key="log_i">
          <div><span class="content">{{log.creatorName}}</span><span class="time">{{log.creationTime | dateformat('yyyy-MM-DD HH:mm:ss') }}</span></div>
          <p class="content">{{log.content}}</p>
        </TimelineItem>

      </Timeline>
      <div slot="footer">
        <Button @click="czShow = false" class="close-btn">关闭</Button>

      </div>
    </Modal>
    <Modal v-model="imgShow" :mask-closable="false" width="1000px" :closable="false" title="大图预览">
      <div class="dt">
        <img :src="url + imgU" style="width: 100%;max-width: 800px; height: auto;max-height: 700px;" />
      </div>
      <div slot="footer">
        <Button @click="imgShow = false" type="primary" class="close-btn">关闭</Button>

      </div>
    </Modal>
    <Modal v-model="isShowResolveQuestion" width="400" :mask-closable="false" :closable="false" title="选择人员">
      <div>
        <Form ref="formResolveQuestion" :model="resolveQuestion" :rules="ruleCustom">
          <FormItem prop="resolvePerson" label="流转到">
            <Select v-model="resolveQuestion.resolvePerson" style="width:300px">
              <Option v-for="(item,index) in resolvePersonList" :key="index" :value="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="closeResolveQuestion" class="close-btn">取消</Button>
        <Button @click="confirmResolveQuestion" type="primary" class="close-btn">流转</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { getDetailByGuid } from '../../../api/index'
import Util from '../../../lib/util'

export default {
  props: {
    showDetail: {
      type: Boolean,
      required: true,
      default: false,
    },
    title: {
      type: String,
      default: '详情',
    },
    guid: {
      type: Array,
      required: true,
    },
    taskId: {
      type: [Number, String],
      // required: true,
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      logList: [],
      rzLoading: false,
      Uploading: false,
      czShow: false,
      newGuid: this.getGuid(),
      isShowResolveQuestion: false,
      resolveQuestion: { resolvePerson: '' },
      imgShow: false,
      url: this.$constDefinition.baseUrl,
      questionTypeList: [],
      resolvePersonList: [],
      form: {
        sceneFeedBackCreatelist: [{ sceneFeedBackFilesSolutionList: [] }],
        sceneDataItemTaskBusinessConfirmFilesList: [],
      },
      ruleCustom: {
        c问题解决: { required: true, message: '请输入', trigger: 'blur' },
        resolvePerson: { required: true, message: '请选择', type: 'number', trigger: 'blur' },
      },
      imgU: '',
      loading: true,
      imgGuid: '',

      dateil: {
        mould: {
          creationTime: '',
          c客户名称: '',
          c模具名称: '',
          c模具型号: '',
          isShow_售后服务: false,
          isShow_指派人员: false,
          isShow_提供解决方案: false,
          isShow_确认接单: false,
          isShow_经理审批: false,
          status: 1,
          statusText: '',
        },
        task: [],
      },
    }
  },
  mounted() {
    this.getQuestionTypeList()
    this.getResolvePersonList()
  },
  methods: {
    getGuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    },
    async openCz(id) {
      this.rzLoading = true
      this.czShow = true
      try {
        const { data } = await this.$Ajax.get(
          `/api/services/app/SceneDataItemTask/GetBusinessLogByTask?taskId=${id}`
        )
        this.logList = data.result
      } catch (err) {}
      this.rzLoading = false
    },
    closeResolveQuestion() {
      this.isShowResolveQuestion = false
      this.resolveQuestion.resolvePerson = ''
      this.$refs['formResolveQuestion'].resetFields()
    },
    // 工艺部流转
    confirmResolveQuestion() {
      let _this = this

      let params = {
        sceneDataGuId: _this.guid[0],
        userId: this.resolveQuestion.resolvePerson,
      }
      console.log('🚀 ~ file: detail.vue:477 ~ confirmResolveQuestion ~ params:', params)
      this.$refs['formResolveQuestion'].validate(async (valid) => {
        if (valid) {
          const { data } = await _this.$Ajax.post(
            '/api/services/app/SceneDataItem/WorkFlow_提供方案_流转',
            params
          )
          if (data.success) {
            _this.$Message.success({
              content: '流转成功',
            })
          }
          this.isShowResolveQuestion = false
          this.close(true)
        }
      })
    },
    //工艺部人员
    async getResolvePersonList() {
      try {
        const { data } = await this.$Ajax.get(
          `/api/services/app/SceneDataItem/GetProcessDeptFlowUserList`
        )
        this.resolvePersonList = data.result.processDeptUserList
      } catch (err) {}
    },
    exportTaskProblemList() {
      var _this = this
      let consturl = ''
      if (_this.taskId) {
        consturl = `${_this.$constDefinition.baseUrl}/api/Export/ExportTaskProblemList?guid=${_this.guid[0]}&taskId=${_this.taskId}` //下载地址url
      } else {
        consturl = `${_this.$constDefinition.baseUrl}/api/Export/ExportTaskProblemList?guid=${_this.guid[0]}` //下载地址url
      }
      const date = this.$moment(new Date()).format('yyyyMMDDHHmm')
      var xhr = new XMLHttpRequest()
      xhr.open('get', consturl, true) // get、post都可
      xhr.responseType = 'blob'
      xhr.setRequestHeader('Authorization', `Bearer ${Util.abp.auth.getToken()}`) //加请求头
      xhr.onload = function () {
        if (xhr.status == 200) {
          let blob = new Blob([this.response], {
            type: 'application/vnd.ms-excel',
          })
          var a = document.createElement('a')
          var url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = `产品问题清单${date}.xlsx` // 文件名
          if (xhr.readyState === 4) {
            _this.$Message.success({
              content: '下载成功',
            })
          }
        } else {
          _this.$Message.error({
            content: '下载失败',
          })
        }
        a.click()
        window.URL.revokeObjectURL(url)
      }
      xhr.send()
    },
    //放大图片
    magnify(flog, imgurl) {
      if (imgurl.indexOf('previewThumbnail') > -1) {
        this.imgU = imgurl.replace('/previewThumbnail', '/preview')
      }
      if (flog) {
        window.open(this.url + this.imgU)
      } else {
        this.imgShow = true
      }
      // window.open(this.url + this.imgU);
    },
    //获取问题类型
    async getQuestionTypeList() {
      try {
        const { data } = await this.$Ajax.get(`/api/services/app/SceneDataItem/GetQuestionTypeList`)
        this.questionTypeList = data.result.questionTypeList
      } catch (err) {}
    },
    ok() {
      let _this = this
      this.$refs['form'][0].validate(async (valid) => {
        if (valid) {
          _this.loading = true
          _this.form.id = _this.taskId //整个任务Guid
          let sceneFeedBackCreatelist = []
          //判断是否需要录入
          this.form.sceneFeedBackCreatelist.forEach((e) => {
            console.log(
              '🚀 ~ file: detail.vue:489 ~ this.form.sceneFeedBackCreatelist.forEach ~ e:',
              e
            )

            if (e.c问题解决 != '') {
              sceneFeedBackCreatelist.push(e)
            }
          })
          // this.form.sceneFeedBackCreatelist = sceneFeedBackCreatelist
          let form = JSON.parse(JSON.stringify(_this.form))
          form.sceneFeedBackCreatelist = sceneFeedBackCreatelist
          let { data } = await this.$Ajax.post(
            `/api/services/app/SceneDataItem/WorkFlow_提供方案_PC`,
            form
          )
          _this.loading = true
          _this.close(true)
        } else {
          this.$Message.error('请将表单填写完整')
        }
      })
    },
    okys() {
      let _this = this
      this.$refs['formys'][0].validate(async (valid) => {
        if (valid) {
          _this.loading = true

          let form = {
            sceneDataItemTaskId: _this.taskId,
            c验收描述: this.form.businessConfirmDescribe,
            sceneFeedBackAcceptFilesList: this.form.sceneDataItemTaskBusinessConfirmFilesList,
          }
          JSON.parse(JSON.stringify(_this.form))
          // form.sceneDataItemTaskId = _this.taskId //整个任务Guid
          console.log("🚀 ~ file: detail.vue:642 ~ this.$refs['formys'][0].validate ~ form:", form)

          let { data } = await this.$Ajax.post(
            `/api/services/app/SceneDataItem/WorkFlow_业务员审批_PC`,
            form
          )
          _this.loading = true
          _this.close(true)
        } else {
          this.$Message.error('请将表单填写完整')
        }
      })
    },
    close(flog) {
      // console.log("🚀 ~ file: detail.vue:604 ~ close ~ close:",this.$parent)
      if (this.title == '录入解决方案') {
        try {
          this.$refs['form'][0].resetFields()
        } catch (error) {}
        // this.$refs['formys'][0].resetFields()
      }
      if (this.title == '验收') {
        try {
          this.$refs['form'][0].resetFields()
        } catch (error) {}
        // this.$refs['formys'][0].resetFields()
      }

      this.$parent.closeShowAfterSale(flog)
      // this.$emit('close',flog)
    },

    //移除图片
    handleRemove(index, imgIndex) {
      // this.dateil.tasks[0].problemList.forEach((item) => {
      // 							item.sceneFeedBackFilesSolutionList.forEach((itm,
      // 								index) => {
      // 								if (itm.url.includes(guid)) {
      // 									item.sceneFeedBackFilesSolutionList
      // 										.splice(index, 1);
      // 								}
      // 							});
      // 						});
      // this.tasks[0].problemList[index].sceneFeedBackFilesSolutionList.splice(index, 1)
      this.form.sceneFeedBackCreatelist[index].sceneFeedBackFilesSolutionList.splice(imgIndex, 1)
    },
    handleRemoveys(imgIndex) {
      this.form.sceneDataItemTaskBusinessConfirmFilesList.splice(imgIndex, 1)
    },
    handleSuccess(res, file) {
      this.form.sceneFeedBackCreatelist[res.result.id].sceneFeedBackFilesSolutionList.push({
        fileGuids: res.result.guid,
        url: res.result.imageUrl,
        fileName: '图片',
      })
      let name = 'upload' + res.result.id
      console.log(
        '🚀 ~ file: detail.vue:541 ~ handleSuccess ~ this.$refs[name]:',
        this.$refs,
        this.$refs[name]
      )

      this.$refs[name][0].clearFiles()
    },
    handleSuccessys(res, file) {
      this.form.sceneDataItemTaskBusinessConfirmFilesList.push({
        fileGuids: res.result.guid,
        url: res.result.imageUrl,
        fileName: '图片',
      })
      let name = 'uploadys'
      console.log(
        '🚀 ~ file: detail.vue:541 ~ handleSuccess ~ this.$refs[name]:',
        this.$refs,
        this.$refs[name]
      )
      this.$refs[name][0].clearFiles()
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: '上传失败',
        desc: '图片上传失败',
      })
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: '图片超出指定大小',
        desc: '图片文件不能超出2M',
      })
    },
    handleBeforeUpload(i) {
      this.newGuid = this.getGuid()
      return true
    },
    // imgok() {
    //   this.imgShow = false
    // this.$parent.closeShowAfterSale()
    // },
  },
  watch: {
    async guid(newV) {
      if (newV) {
        let _this = this
        this.loading = true
        let data
        // this.guid = newV
        if (this.taskId) {
          data = await getDetailByGuid({ guid: newV[0], taskId: this.taskId })
        } else {
          data = await getDetailByGuid({ guid: newV[0] })
        }
        this.dateil = data.data.result

        if (this.title == '录入解决方案') {
          //录入解决问题时
          let form = { sceneFeedBackCreatelist: [], id: this.taskId, isCommit: true }
          this.dateil.tasks[0].problemList.forEach((element) => {
            form.sceneFeedBackCreatelist.push({
              sceneDataItemTaskId: _this.taskId,
              c问题解决: '',
              id: element.id,
              sceneFeedBackFilesSolutionList: [],
            })
          })
          this.form = form
          //  this.form.sceneFeedBackCreatelist.forEach((element,i) => {
          //  this.form.sceneFeedBackCreatelist[i].sceneFeedBackFilesSolutionList = this.$refs['upload'+i].fileList;
          // form.sceneFeedBackCreatelist.push({
          //   sceneDataItemTaskId: _this.taskId,
          //   c问题解决: '',
          //   id: element.id,
          //   sceneFeedBackFilesSolutionList: [],
          // })

          // })
        }
        this.loading = false
      }
    },
  },
}
</script>
<style scoped lang="less">
.hander2 {
  height: 80px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.isSF {
  position: relative;
  top: -10px;
}
.cz /deep/.ivu-modal-body {
  max-height: 600px;
  overflow: auto;
}
/deep/ .ivu-divider-horizontal.ivu-divider-with-text-left:before {
  border-top-color: #2d8cf0 !important;
}
/deep/ .ivu-divider-horizontal.ivu-divider-with-text-left:after {
  border-top-color: #2d8cf0 !important;
}
/deep/ .ivu-divider-inner-text {
  color: #2d8cf0 !important;
}
/deep/.ivu-col {
  margin: 3px 0px;
}
.ctime {
  position: relative;
  top: -50px;
  right: -450px;
  color: #818181;
}
.dd {
  position: relative;
  max-height: 600px;
  overflow: auto;
}
.top_info {
  background: rgb(230, 230, 230);
  padding: 12px;
  border-radius: 5px;
}
.t_c {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px dashed #2d8cf0;
  padding: 0px 0px 5px 0px;
}
.dt {
  display: flex;
  justify-content: center;
  max-width: 100%;
}
.img {
  margin-right: 10px;
}
.pos {
  position: relative;
}
.pos:hover .img_magnify {
  display: inline-block;
}
.ico {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.time {
  margin-left: 10px;
  color: rgb(182, 182, 182);
}
.img_magnify {
  display: none;
  background: rgba(0, 0, 0, 0.459);
  position: absolute;
  z-index: 1;
  width: 80px;
  height: 80px;
  left: 0px;
}
.wrap {
  margin: 0px 0px 15px 0px;
  background: rgb(230, 230, 230);
  padding: 10px;
}
.wrap:nth-last-of-type(1) {
  margin: 0px 0px 0px 0px;
}
.box {
  // max-height: 450px;
  // overflow: auto;
}
.time {
  color: #5e5e5e;
}
/*滚动条整体粗细样式*/
::-webkit-scrollbar {
  /*高宽分别对应横竖滚动条的尺寸*/
  width: 0px;
  height: 0px;
}

/*滚动条里面小方块*/
::-webkit-scrollbar-thumb {
  border-radius: 3px !important;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2) !important;
  /* 颜色 */
  /* background:#b6b6b6!important; */
  /* 线性渐变背景 */
  background-image: linear-gradient(45deg, #00000080 25%, #00000080 25%) !important;
}

/*滚动条轨道*/
::-webkit-scrollbar-track {
  border-radius: 10px !important;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2) !important;
  background: #ededed !important;
}
.typeCls {
  color: #2d8cf0;
}
.up .ivu-form-item {
  margin-bottom: 5px;
}
</style>
